import HttpReference from '../platform/HttpReference';
import Delivery from './Delivery';

export default class Deliveries extends HttpReference {
  get childReferenceType() {
    return Delivery;
  }
}
